import ContextualVoucher from "./blibli/contextual-voucher";
import Blibli4You from "./blibli/blibli-4-you";
import BlibliCheckoutProjects from "./blibli/blibli-checkout-projects";
import BlibliHisteria from "./blibli/blibli-histeria";
import BlibliIllustration from "./blibli/blibli-illustration";
import FinalProject from "./uni/final-project";
import TravelokaFlexibleDiscovery from "./traveloka/flexible-discovery";
import TravelokaMaudi from "./traveloka/maudi";
import TravelokaSedap from "./traveloka/sedap";
import Hagah from "./independent/hagah";
//import Modelling from "./uni/3d-model";
import { CompaniesDataProps, CompanyDataProps } from "./props";

// URUTAN PENTING
export default {
  companies: [
    {
      name: "Traveloka",
      timeline: "2022 - May 2024",
      projects: [TravelokaMaudi, TravelokaSedap, TravelokaFlexibleDiscovery],
    } as CompanyDataProps,
    {
      name: "Blibli",
      timeline: "2018, 2019-2022",
      projects: [
        ContextualVoucher,
        Blibli4You,
        BlibliCheckoutProjects,
        BlibliHisteria,
        BlibliIllustration,
      ],
    } as CompanyDataProps,
    {
      name: "Uni Life",
      timeline: "2015-2019",
      projects: [FinalProject],
    } as CompanyDataProps,
  ],
  independentProjects: [Hagah],
} as CompaniesDataProps;
